import React from "react";
import * as styles from "./Cta.module.css";
import { Link } from "../Link/Link";

interface CommonCtaProps {
  codename?: string;
  label?: string | JSX.Element;
  large?: boolean;
  invert?: boolean;
  className?: string;
  buttonStyle?: "turquoise" | "white";
}

export interface LinkCtaProps extends CommonCtaProps {
  button?: false;
  href: string;
  target?: string;
  pageTitle?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

interface ButtonCtaProps extends CommonCtaProps {
  button: true;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

type CtaProps = LinkCtaProps | ButtonCtaProps;

export const Cta: React.FC<CtaProps> = (props) => {
  // using 'props' b/c typescript doesn't like
  // destructuring interdependent props ()
  const cssStyles = [styles.cta];
  const {
    className,
    large,
    invert,
    buttonStyle,
    button,
    codename,
    label,
    ...rest
  } = props;

  if (className) {
    cssStyles.push(className);
  }

  if (large) {
    cssStyles.push(styles.large);
  }
  if (invert) {
    cssStyles.push(styles.invert);
  }

  if (buttonStyle && styles[buttonStyle]) {
    cssStyles.push(styles[buttonStyle]);
  }

  if (button) {
    return (
      <button
        type="button"
        data-kontent-element-codename={codename}
        className={cssStyles.join(" ")}
        {...rest}
      >
        {label}
      </button>
    );
  } else {
    return (
      <Link
        className={cssStyles.join(" ")}
        data-kontent-element-codename={codename}
        to={props.href}
        {...rest}
      >
        {label}
      </Link>
    );
  }
};
